import { Grid, Paper } from "@mui/material";
import { ICompany, IRegistrationSheet } from '../../models/registrationModels';
import RsDataField from "./RsDataField";
import GridItemContainer from "../layout/GridItemContainer";

type Props = {
  company: ICompany;
  registrationSheet: IRegistrationSheet;
};

const RsHeader = ({ company, registrationSheet }: Props) => {
  return (
    <Paper elevation={2}>
      <Grid container>
        <GridItemContainer xs={6} md={4}>
          <RsDataField labelStrong="Gästeverzeichnisblatt" labelSmall="lfd. Nr." value={registrationSheet.number} />
        </GridItemContainer>
        <GridItemContainer xs={6} md={4}>
          <RsDataField labelSmall="Name des Beherbergungsbetriebes" value={company.name} />
        </GridItemContainer>
        <GridItemContainer xs={6} md={4}>
          <RsDataField labelSmall="Betriebsnummer" value={company.number} />
        </GridItemContainer>
      </Grid>
    </Paper>
  );
};

export default RsHeader;
